import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendComparisonSet,
  BackendMutationPerformanceCenterSaveBenchmarkModelArgs,
} from 'src/types/backend';

import { COMPARISON_SET_FRAGMENT } from './schema';

const MUTATION = gql`
  mutation PerformanceCenterSaveBenchmarkModel(
    $customerId: ID!
    $accountId: ID!
    $dataSource: PerformanceCenterDataSource!
    $name: String!
    $description: String!
    $userGoals: [String!]!
    $examples: [[String!]!]!
    $assetType: String!
    $deletedExamples: [[String!]!]!
    $examplesWithMetrics: [[ComparisonSetExampleInput!]!]!
  ) {
    performanceCenterSaveBenchmarkModel(
      customerId: $customerId
      accountId: $accountId
      dataSource: $dataSource
      name: $name
      description: $description
      userGoals: $userGoals
      examples: $examples
      assetType: $assetType
      deletedExamples: $deletedExamples
      examplesWithMetrics: $examplesWithMetrics
    ) {
      ...ComparisonSet
    }
  }
  ${COMPARISON_SET_FRAGMENT}
`;

type Variables = BackendMutationPerformanceCenterSaveBenchmarkModelArgs;
type Result = BackendComparisonSet[];

export const performanceCenterSaveBenchmarkModel = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      traceAcRequests: true,
    },
  });
  return getSingleProp<Result>(result.data);
};
